<template>
  <div class="box">
    <el-card class="message_top">
      <el-form
        label-position="right"
        label-width="80px"
        :model="infoFrom"
        class="from"
      >
        <el-form-item label="员工工号">
          <el-input
            placeholder="请输入员工工号"
            v-model="infoFrom.empNo"
            @input="inputEmpno"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="员工姓名">
          <el-input
            placeholder="请输入员工姓名"
            v-model="infoFrom.name"
            @input="inputName"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="年份">
          <el-date-picker
            v-model="infoFrom.year"
            type="year"
            placeholder="选择年份"
            clearable
            @change="changeYear"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div class="search">
        <el-button type="primary" @click="search">点击查询</el-button>
        <el-button type="info" @click="handelExport">导出</el-button>
      </div>
    </el-card>
    <el-card class="message_center">
      <el-table
        v-loading="loading"
        max-height="520"
        :data="tableData"
        style="width: 100%"
        border
      >
        <!-- <el-table-column prop="id" label="id" width="100" show-overflow-tooltip>
        </el-table-column> -->
        <el-table-column
          prop="year"
          label="年度"
          width="120"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="empNo"
          label="工号"
          width="120"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column prop="name" label="姓名" width="120" show-overflow-tooltip>
        </el-table-column>
<!--        <el-table-column-->
<!--          prop="departmentname"-->
<!--          label="组织"-->
<!--          show-overflow-tooltip-->
<!--        >-->
<!--        </el-table-column>-->
<!--        <el-table-column-->
<!--          prop="jobtitlename"-->
<!--          label="岗位"-->
<!--          show-overflow-tooltip-->
<!--        >-->
<!--        </el-table-column>-->
<!--        <el-table-column-->
<!--          prop="startdate"-->
<!--          label="入职日期"-->
<!--          width="120"-->
<!--          show-overflow-tooltip-->
<!--        >-->
<!--        </el-table-column>-->
<!--        <el-table-column-->
<!--          prop="probationenddate"-->
<!--          label="试用结束日期"-->
<!--          width="120"-->
<!--          show-overflow-tooltip-->
<!--        >-->
<!--        </el-table-column>-->
        <el-table-column
            prop="validChildrenCount"
            label="当期有效子女数"
            width="120"
            show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
            prop="parityBirthday"
            label="有效胎次/出生日期"
            width="120"
            show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
            prop="holidayStartTime"
            label="子女有效开始日期"
            width="120"
            show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
            prop="holidayEndTime"
            label="子女有效截止日期"
            width="120"
            show-overflow-tooltip
        >
        </el-table-column>
<!--        <el-table-column-->
<!--          prop="djt"-->
<!--          label="胎次"-->
<!--          width="120"-->
<!--          show-overflow-tooltip-->
<!--        >-->
<!--          <template slot-scope="{ row }">-->
<!--            <span v-if="row.djt == '0'">首胎</span>-->
<!--            <span v-if="row.djt == '1'">第二胎</span>-->
<!--            <span v-if="row.djt == '2'">第三胎</span>-->
<!--            <span v-if="row.djt == '0/1'">首胎/第二胎</span>-->
<!--            <span v-if="row.djt == '0/1/2'">首胎/第二胎/第三胎</span>-->
<!--            <span v-if="row.djt == '1/2'">第二胎/第三胎</span>-->
<!--          </template>-->
<!--        </el-table-column>-->
<!--        <el-table-column-->
<!--          prop="zncsrq"-->
<!--          label="胎儿出生日期"-->
<!--          width="140"-->
<!--          show-overflow-tooltip-->
<!--        >-->
<!--          <template slot-scope="{ row }">-->
<!--            <span>{{row.zncsrq}}</span>-->
<!--          </template>-->
<!--        </el-table-column>-->
<!--        <el-table-column-->
<!--          prop="holidaytype"-->
<!--          label="假期类型"-->
<!--          width="120"-->
<!--          show-overflow-tooltip-->
<!--        >-->
<!--        </el-table-column>-->
        <el-table-column
          prop="ksxyrq"
          label="年度开始享受日期"
          width="120"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="effexpirationdate"
          label="年度截止日期"
          width="120"
          show-overflow-tooltip
        >
          <template slot-scope="{ row }">
            <span v-if="row.id" style="color: blue; cursor: pointer">
              {{ row.effexpirationdate }}
            </span>
            <span v-else>
              {{ row.effexpirationdate }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
            prop="canEnjoyDay"
            label="可享假期（天数）"
            show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
            prop="canEnjoyHour"
            label="可享假期（小时）"
            show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
            prop="zkc"
            label="已扣除（小时）"
            show-overflow-tooltip
        >
        </el-table-column>
<!--        <el-table-column-->
<!--          prop="total"-->
<!--          label="总结余"-->
<!--          show-overflow-tooltip-->
<!--        >-->
<!--        </el-table-column>-->
<!--        <el-table-column-->
<!--          prop="zkc"-->
<!--          label="总扣减"-->
<!--          show-overflow-tooltip-->
<!--        >-->
<!--        </el-table-column>-->
        <el-table-column
          prop="balance"
          label="结余（小时）"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
            prop="canEnjoyBalanceDay"
            label="结余（天数）"
            show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
            prop="balance"
            label="可用（小时）"
            show-overflow-tooltip
        >
          <template slot-scope="{ row }">
            <span v-if="row.state === 1" style="color: blue; cursor: pointer">
              {{ row.balance }}
            </span>
            <span v-else>
              {{ 0 }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
            prop="state"
            label="有效期状态"
            show-overflow-tooltip
        >
          <template slot-scope="{ row }">
            <span  style="color: blue; cursor: pointer">
              {{ row.state == 1 ? "生效" : row.state == 2 ? "失效" : "待生效" }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
            prop="reason"
            label="失效原因"
            show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
            prop="empState"
            label="员工状态"
            show-overflow-tooltip
        >
          <template slot-scope="{ row }">
            <span  style="color: blue; cursor: pointer">
              {{ row.empState == 0 ? "在职" : row.empState == 1 ? "离职" : "其他状态" }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120" show-overflow-tooltip>
          <template slot-scope="{ row }">
            <el-button
              v-if="row.state == 1 && row.empState == 0"
              type="primary"
              size="mini"
              @click="openEditDialog(row)"
            >
              编辑
            </el-button>
            <span v-else>--</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="pager">
        <el-pagination
          :current-page="pageData.page"
          :page-size="10"
          :total="total"
          @size-change="sizeChange"
          @current-change="currChange"
          layout="total, prev, pager, next, jumper"
        />
      </div>
    </el-card>
    <el-dialog title="更改截止时间" :visible.sync="dialog" width="30vw">
      <el-form :model="formDialog">
        <el-form-item label="选择年月">
          <el-date-picker
            v-model="formDialog.year"
            type="date"
            placeholder="选择年份"
            clearable
            @change="changeDialogYear"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialog = false">取 消</el-button>
        <el-button type="primary" @click="handleDialog"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      title="编辑"
      :visible.sync="editDialogVisible"
      width="650px"
      custom-class="parental-edit-dialog"
    >
      <el-form
        class="edit-form"
        :model="editForm"
        label-width="120px"
        label-position="left"
      >
        <el-form-item label="员工姓名:">
          <span class="edit-value">{{ editForm.name || "--" }}</span>
        </el-form-item>
        <el-form-item label="员工工号:">
          <span class="edit-value">{{ editForm.empNo || "--" }}</span>
        </el-form-item>
        <el-form-item label="员工状态:">
          <span class="edit-value">{{ editForm.empStateText || "--" }}</span>
        </el-form-item>
        <el-form-item label="离职日期:">
          <el-date-picker
            v-model="editForm.resignDate"
            type="date"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            placeholder="请选择离职日期"
            clearable
            class="edit-date-picker"
          />
        </el-form-item>
        <div class="edit-tip">离职日期即为年度截止日期</div>
      </el-form>

      <div slot="footer" class="edit-footer">
        <el-button class="submit-btn" type="primary" @click="submitEditDialog"
          >提交</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from "@/apis";
import { downloadExcel } from "@/utils/tools";
import moment from "moment";
// import moment from "moment";
export default {
  data() {
    return {
      // 表单绑定
      infoFrom: {
        empNo: "",
        name:'',
        year: "",
      },
      formDialog: {
        year: "",
      },
      // 分页
      pageData: {
        page: 1,
      },
      // 数据总条数
      total: 0,
      // 表格数据
      tableData: [],
      // 加载中
      loading: false,
      code: "",
      dialog: false,
      id:'',
      editDialogVisible: false,
      editRowEmpNo: "",
      editForm: {
        name: "",
        empNo: "",
        empStateText: "",
        resignDate: "",
      },
    };
  },
  watch: {
    // infoFrom: {
    //   deep: true,
    //   handler() {
    //     this.$nextTick(()=>{
    //       this.pageData.page = 1;
    //     })
    //   },
    // },
  },
  mounted() {
    this.getList();
  },
  methods: {
    // 获取列表数据
    getList() {
      this.loading = true;
      api
        .parentingList({ ...this.infoFrom, ...this.pageData })
        .then((data) => {
          this.tableData = data.data;
          console.log(data, "data");
          this.total = data.total;
          this.code = data.code;
        })
        .finally(() => (this.loading = false));
    },
    //员工工号
    inputEmpno(value){
      this.infoFrom.empNo = value
      this.getList()
    },
    // 员工姓名
    inputName(value){
      this.infoFrom.name = value
      this.getList()
    },
    // 打开日期弹窗
    setDialog(id){
      this.dialog = true
      this.id = id
    },
    // 分页变化
    sizeChange(value) {
      this.pageData.pageShow = value;
      this.getList();
    },
    // 分页变化
    currChange(value) {
      this.pageData.page = value;
      this.getList();
    },
    // 查询按钮
    search() {
      this.pageData.page = 1;
      if(!this.infoFrom.year){
        this.infoFrom.year = ''
      }
      if(!this.infoFrom.empNo){
        this.infoFrom.empNo = ''
      }
      this.getList();
    },
    // 切换日期
    changeYear(value) {
      this.infoFrom.year =  value ? moment(value).format("YYYY") : '';
      this.getList()
    },
    // 切换弹窗日期
    changeDialogYear(value){
      this.formDialog.year = moment(value).format("YYYY-MM-DD");
    },
    // 弹窗确认按钮
    handleDialog(){
      api.parentingEdit({id:this.id,effexpirationdate:this.formDialog.year}).then(()=>{
        this.dialog = false
        this.getList()
        this.$message({
          type: 'success', // success error warning
          message: '修改成功',
          duration: 1000,
        })
      })
    },
    // 导出
    handelExport() {
      if (this.code) {
        this.loading = true;
        api
          .parentingExcel({ ...this.infoFrom })
          .then((data) => {
            downloadExcel(data, "导出文件", "xls");
            this.$message.success("导出成功!");
          })
          .finally(() => (this.loading = false));
      } else {
        this.$message.warning("请数据加载完后再导出!");
      }
    },
    openEditDialog(row) {
      this.editRowEmpNo = row?.empNo || "";
      this.editForm.name = row?.name || "";
      this.editForm.empNo = row?.empNo || "";
      this.editForm.empStateText =
          row?.empState == 0 ? "在职" : row?.empState == 1 ? "离职" : "其他状态";
      // 默认取当前“年度截止日期”，用户可在弹窗内修改（与截图“离职日期即为年度截止日期”一致）
      this.editForm.resignDate = row?.effexpirationdate || "";
      this.editDialogVisible = true;
    },
    submitEditDialog() {
      if (!this.editRowEmpNo) {
        this.$message.warning("未获取到工号");
        return;
      }
      if (!this.editForm.resignDate) {
        this.$message.warning("请选择离职日期");
        return;
      }
      api
        .parentingLeaveEdit(
          {},
          {
            params: {
              empNo: this.editRowEmpNo,
              resignTime: this.editForm.resignDate,
            },
          }
        )
        .then(() => {
          this.editDialogVisible = false;
          this.getList();
          this.$message({
            type: "success",
            message: "修改成功",
            duration: 1000,
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  width: 100vw;
  min-height: 100vh;
  padding: 20px;
  display: flex;
  flex-direction: column;
}
.message_top {
  height: 26vh;
  padding-left: 180px;
  overflow: auto;
  padding-bottom: 50px;
}
.message_center {
  flex: 1;
  margin-top: 20px;
  .pager {
    margin-top: 50px;
    float: right;
  }
}
.from {
  width: 100%;
  height: 100%;
  padding-top: 20px;
  display: grid;
  grid-template-columns: 40% 40%;
  grid-column-gap: 200px;
  position: relative;
}
.explanatory {
  color: rgb(248, 101, 101);
  position: absolute;
  top: 320px;
  right: 340px;
}
.search {
  margin-top: -30px;
  //   padding-left: 70.5%;
  float: right;
  margin-right: 380px;
  button {
    width: 180px;
    height: 80px;
    // margin-top: 10px;
    margin-left: 60px;
  }
}
/* 顶部查询表单的统一样式（避免影响下方弹窗） */
.message_top {
  ::v-deep {
    .el-input__inner {
      height: 80px;
      margin-bottom: 50px;
    }
    .el-form-item__label {
      line-height: 80px;
    }
    .el-date-editor.el-input {
      width: 100%;
    }
    .el-input__prefix {
      height: 80px;
    }
    .el-select {
      width: 100%;
    }
    .el-input__suffix {
      height: 80px;
    }
  }
}

.message_center {
  ::v-deep {
    .cell {
      height: 60px;
      text-align: center;
      line-height: 60px;
      font-size: 30px;
    }
  }
}

/* 编辑弹窗美化样式 */
::v-deep .parental-edit-dialog {
  .el-dialog__header {
    text-align: center;
    padding: 20px 20px 10px;
    border-bottom: 1px solid #ebeef5;
  }
  .el-dialog__title {
    font-size: 18px;
    font-weight: 600;
    color: #303133;
  }
  .el-dialog__body {
    padding: 30px 40px;
  }
  .el-dialog__footer {
    padding: 20px 40px 30px;
    border-top: 1px solid #ebeef5;
  }
}

.edit-form {
  width: 100%;
  max-width: 500px;
  margin: 0 auto;
  text-align: left;
  font-size: 32px;
  /* 每行两列：左侧标签固定宽度，右侧内容自适应（图二效果） */
  ::v-deep .el-form-item {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 24px;
  }
  ::v-deep .el-form-item__label {
    float: none;
    width: 120px;
    text-align: left;
    padding: 0 12px 0 0;
    box-sizing: border-box;
    line-height: 32px;
    font-size: 18px;
    color: #606266;
    font-weight: 500;
  }
  ::v-deep .el-form-item__content {
    float: none;
    margin-left: 0 !important;
    flex: 1;
    line-height: 32px;
  }
  .el-form-item {
    &:last-child {
      margin-bottom: 0;
    }
  }
}

.edit-value {
  font-size: 20px;
  color: #303133;
  line-height: 32px;
  display: inline-block;
  min-height: 32px;
}

.edit-date-picker {
  width: 280px;
  ::v-deep .el-input__inner {
    height: 36px;
    line-height: 36px;
    font-size: 18px;
  }
  ::v-deep .el-input__prefix {
    left: 10px;
    top: 70%;
    transform: translateY(-50%);
    line-height: 1;
    .el-input__icon {
      line-height: 1;
      height: auto;
    }
  }
  ::v-deep .el-input__suffix {
    line-height: 36px;
    .el-input__icon {
      line-height: 36px;
      height: 36px;
    }
  }
}

.edit-tip {
  margin: 12px 0 0 120px;
  width: 280px;
  text-align: center;
  color: #909399;
  font-size: 20px;
  line-height: 20px;
}

.edit-footer {
  text-align: center;
  padding: 0;
}

.submit-btn {
  width: 120px;
  height: 40px;
  font-size: 14px;
  font-weight: 500;
  border-radius: 4px;
}
</style>
